import client from '../client';

export const paging = client.api.odlBuildHistoryControllerList;

export const registerDeployment = (fileIds: string[]) =>
  client.api.odlBuildControllerRegister({ fileIds });

export const registerRedeploy = (taskId: number) =>
  client.api.odlBuildControllerRegisterRedeploy(taskId);
